export class LazyLoadRevealHandler {
    constructor() {
        this.lazyImages = document.querySelectorAll('[jss="lazy-reveal"] img');
        this.observerOptions = {
            root: null,
            rootMargin: "0px 0px 0px 0px",
            threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
        };
        this.lazyImageObserver = new IntersectionObserver((entries, observer) => this.onIntersectObserver(entries, observer), this.observerOptions);
        this.lazyImages.forEach((lazyImage) => {
            if (lazyImage instanceof HTMLImageElement) {
                lazyImage.classList.add("transition-reveal", "duration-250", "opacity-0", "lazy-filter", "ease-reveal");
                let revealNode = document.createElement("span");
                revealNode.classList.add("bg-brand-grey", "absolute", "inset-0", "transition-reveal", "duration-250", "ease-reveal");
                lazyImage.parentNode.appendChild(revealNode);
                this.lazyImageObserver.observe(lazyImage);
                if (!lazyImage.complete) {
                    lazyImage.addEventListener("load", () => this.tryReveal(lazyImage));
                }
                else {
                    this.lazyImageObserver.unobserve(lazyImage);
                    this.reveal(lazyImage);
                }
            }
        });
    }
    onIntersectObserver(entries, observer) {
        const self = this;
        entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.target instanceof HTMLImageElement) {
                let lazyImage = entry.target;
                self.tryReveal(lazyImage);
            }
        });
    }
    tryReveal(lazyImage) {
        let self = this;
        if (lazyImage.complete) {
            self.reveal(lazyImage);
            self.lazyImageObserver.unobserve(lazyImage);
        }
        else {
            setTimeout(() => {
                self.tryReveal(lazyImage);
            }, 20);
        }
    }
    reveal(lazyImage) {
        let reveal = lazyImage.parentNode.lastChild;
        if (reveal instanceof HTMLElement) {
            reveal.style.opacity = "0";
            lazyImage.classList.remove("lazy-filter", "opacity-0");
            reveal.addEventListener("transitionend", () => {
                reveal.remove();
            });
        }
    }
}
